<template>
  <Modal
    v-if="settings.show"
    title="Warning!"
    :submit-btn-text="buttonText"
    :delete-btn-text="deleteButtonText"
    :width="500"
    @submit="handleCancel"
    @delete="deleteHandler"
    @hide-modal="handleCancel(true)"
  >
    <div class="form-group mb-0">
      <WarningMessage>{{ warningMessage }}</WarningMessage>
      <p class="mb-4">{{ warningReason }}</p>
      <p v-if="allowContinue" class="mb-4">
        If you proceed, any changes made will not be sent to your accounting
        system (e.g. QuickBooks).
      </p>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import WarningMessage from "serviceshift-ui/components/General/WarningMessage.vue";
import { computed } from "vue";
import { useStore } from "vuex";

import Modal from "@/components/Modal.vue";

const store = useStore();
const settings = computed(() => {
  return store.state.importedDataWarning;
});

const allowContinue = computed(() => {
  return store.getters.internalUser;
});

const handleCancel = (noRedirect = false) => {
  if (!noRedirect && buttonLink.value) {
    window.location.href = buttonLink.value;
    return;
  }
  store.dispatch("cancelImportedDataWarning");
};

const deleteHandler = computed(() => {
  if (!allowContinue.value) {
    return null;
  }

  return handleConfirm;
});

const handleConfirm = () => {
  if (!allowContinue.value) {
    return;
  }

  store.dispatch("confirmImportedDataWarning");
};

const warningMessage = computed(() => {
  switch (settings.value.context) {
    case "add-appointment":
    case "new-quote":
      return "You are making changes to an imported job.";
    case "edit-invoice":
      return "You are making changes to an imported invoice.";
    default:
      return "You are making changes to an imported record";
  }
});

const warningReason = computed(() => {
  switch (settings.value.context) {
    case "add-appointment":
      return "New appointments should not be added to jobs that are imported for historical reporting.";
    case "new-quote":
      return "New quotes should not be added to jobs that are imported for historical reporting.";
    case "edit-invoice":
      return "Changes should not be made to invoices that are imported for historical reporting.";
    default:
      return "";
  }
});

const buttonText = computed(() => {
  switch (settings.value.context) {
    case "add-appointment":
    case "new-quote":
      return "Create a New Job";
    default:
      return "Cancel";
  }
});

const deleteButtonText = computed(() => {
  return allowContinue.value ? "Continue Anyway" : null;
});

const buttonLink = computed(() => {
  const customerId = settings.value.record?.customer?.id;
  const addressId = settings.value.record?.address?.id;

  switch (settings.value.context) {
    case "add-appointment":
    case "new-quote":
      return `/customers/${customerId}?schedule_address_id=${addressId}`;
    default:
      return "";
  }
});
</script>

<style lang="scss" scoped></style>
